var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralizacjazapachwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.94 52.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.96,21.22h3.1v3h-3.1v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.92,45.7h3.1v3h-3.1v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.84,26.89h3.1v3h-3.1v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.21,1.96h3.1v3h-3.1V1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.62,21.22h3.1v3h-3.1v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.35,35.68c-1.73,0-3.15,1.41-3.15,3.15s1.41,3.15,3.15,3.15,3.15-1.41,3.15-3.15-1.41-3.15-3.15-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.07,29.62c-.1-3.63-3.06-6.54-6.71-6.54s-6.64,2.94-6.71,6.59c-3.5-1.05-7.2.89-8.32,4.38-1.11,3.48.75,7.19,4.18,8.39-2.05,3-1.34,7.09,1.62,9.23,2.96,2.14,7.07,1.51,9.27-1.37,2.21,2.87,6.33,3.48,9.28,1.32,2.95-2.15,3.63-6.25,1.57-9.24,3.42-1.21,5.27-4.94,4.13-8.41-1.13-3.47-4.82-5.39-8.3-4.35h0ZM15.35,45.08c-3.45,0-6.25-2.8-6.25-6.25s2.8-6.25,6.25-6.25,6.25,2.8,6.25,6.25-2.8,6.25-6.25,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.77,15.75c1.3,0,2.36-1.06,2.36-2.36s-1.06-2.36-2.36-2.36-2.36,1.06-2.36,2.36,1.06,2.36,2.36,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.47,16.61c-1.75,2.57-1.15,6.09,1.39,7.92,2.54,1.83,6.07,1.3,7.95-1.18,1.9,2.47,5.43,2.98,7.96,1.14,2.53-1.85,3.11-5.36,1.35-7.93,2.93-1.04,4.52-4.24,3.55-7.21s-4.13-4.62-7.12-3.74c-.08-3.11-2.63-5.61-5.76-5.61s-5.7,2.52-5.76,5.65c-3-.9-6.18.77-7.14,3.76-.96,2.98.65,6.17,3.58,7.2h0ZM39.77,7.93c3.01,0,5.46,2.45,5.46,5.46s-2.45,5.46-5.46,5.46-5.46-2.45-5.46-5.46,2.45-5.46,5.46-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.56,33.23c-.05-1.86-1.57-3.35-3.44-3.35s-3.4,1.5-3.44,3.37c-1.79-.54-3.69.46-4.26,2.24-.57,1.78.39,3.68,2.14,4.29-1.05,1.53-.69,3.63.83,4.73s3.62.77,4.75-.7c1.13,1.47,3.24,1.78,4.75.68,1.51-1.1,1.86-3.2.8-4.73,1.75-.62,2.7-2.53,2.12-4.31s-2.47-2.76-4.25-2.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.82,13.35c-1.04,1.53-.69,3.62.83,4.71s3.61.77,4.73-.7c1.13,1.47,3.23,1.78,4.74.68,1.51-1.1,1.85-3.19.8-4.72,1.75-.62,2.69-2.52,2.11-4.3s-2.46-2.75-4.24-2.22c-.05-1.85-1.56-3.34-3.43-3.34s-3.39,1.5-3.43,3.36c-1.79-.53-3.68.46-4.25,2.24-.57,1.78.38,3.67,2.13,4.28h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralizacjazapachwIcon);
export default __webpack_public_path__ + "static/media/Neutralizacja zapachów_icon.b7570b70ecff22cca09987d08f21a536.svg";
export { ForwardRef as ReactComponent };